const INVALID_FILE_NAME_CHARACTERS = /[<>:"/\\|?*]/g

export function sanitizePrintFileNameSegment(value: string, fallback: string): string {
  const sanitized = value
    .trim()
    .replace(INVALID_FILE_NAME_CHARACTERS, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
  return sanitized || fallback
}

/**
 * `YYMMDD_HH_mm` in Korea Standard Time regardless of the browser's zone. Print file names are operational
 * Korean timestamps (AGENTS.md "Date And Time"), so an offset-bearing ISO string (`Z` / `+09:00`) formats the
 * same on every machine. Falls back to `date-unknown` for an unparsable value.
 */
export function formatPrintFileNameTimestampKst(value: string | Date): string {
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return 'date-unknown'
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Seoul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(date)
      .map((part) => [part.type, part.value]),
  )
  return `${parts.year.slice(-2)}${parts.month}${parts.day}_${parts.hour}_${parts.minute}`
}

export function formatPrintFileNameTimestamp(value: Date): string {
  const p = (n: number) => String(n).padStart(2, '0')
  return `${String(value.getFullYear()).slice(-2)}${p(value.getMonth() + 1)}${p(value.getDate())}_${p(
    value.getHours(),
  )}_${p(value.getMinutes())}`
}
